import { MultiSelect } from '@skupreme/shared/ui';
import type { DivisionRef } from '@features/account-view/scope';

export type DivisionFilterProps = {
  divisions: readonly DivisionRef[];
  /** Ids of the divisions the list is narrowed to; none means every division. */
  values: readonly string[];
  onChange: (ids: string[]) => void;
  className?: string;
};

/* EN-4396: the account level's filter by division, built like the marketplace one. */
export function DivisionFilter({
  divisions,
  values,
  onChange,
  className,
}: DivisionFilterProps) {
  return (
    <MultiSelect
      aria-label="Division"
      options={divisions.map(({ id, name }) => ({ value: id, label: name }))}
      values={[...values]}
      onChange={onChange}
      placeholder="All divisions"
      className={className}
    />
  );
}
